
import { prefersReducedMotion } from '@theme/utilities';

function initDayNight() {
  const sw = document.querySelector('[data-daynight]');
  if (!sw) return;
  const item = sw.closest('.pdp-gallery__item');
  sw.addEventListener('click', () => {
    const night = sw.getAttribute('aria-checked') !== 'true';
    sw.setAttribute('aria-checked', String(night));
    item?.classList.toggle('is-night', night);
  });
}

function initTabs() {
  for (const tab of document.querySelectorAll('[data-pdp-tab]')) {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      const id = tab.getAttribute('href');
      let target = id && document.querySelector(id);
      // La galleria e' display: contents per entrare nella griglia della pagina, quindi non ha un
      // box e scrollIntoView su di lei non fa nulla: si punta al primo figlio che un box ce l'ha.
      while (target && !target.getClientRects().length) target = target.firstElementChild;
      if (!target) return;
      target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    });
  }
}

const statusEl = document.querySelector('[data-atc-status]');

function announce(message) {
  if (statusEl) statusEl.textContent = message || '';
}

function accessorioScelto() {
  const scelto = document.querySelector('[data-accessory-opt][aria-pressed="true"]');
  return scelto?.dataset.accessoryOpt || null;
}

async function addToCart(variantId, addUrl, conAccessorio = false, form = null) {
  const cartEl = document.querySelector('[data-drawer="cart"]');
  const sectionId = cartEl?.dataset.sectionId;
  const accessorio = conAccessorio ? accessorioScelto() : null;
  let body;
  let headers = { Accept: 'application/json' };

  if (accessorio) {
    const payload = { items: [{ id: variantId, quantity: 1 }, { id: accessorio, quantity: 1 }] };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }
    body = JSON.stringify(payload);
    headers = { ...headers, 'Content-Type': 'application/json' };
  } else {
    // Partendo dal form si portano dietro anche i campi agganciati con l attributo form: sulla
    // gift card sono destinatario, mittente, messaggio e data di invio, senza i quali Shopify
    // emette un codice che non arriva a nessuno.
    body = form ? new FormData(form) : new FormData();
    body.set('id', variantId);
    body.set('quantity', '1');
    if (sectionId) {
      body.set('sections', sectionId);
      body.set('sections_url', window.location.pathname);
    }
  }
  try {
    const response = await fetch(addUrl, { method: 'POST', headers, body });
    const data = await response.json();
    if (!response.ok) {
      // Sugli errori di validazione della gift card `description` e' un oggetto, non una stringa:
      // stamparlo cosi' com e' darebbe "[object Object]". `message` e' sempre testo.
      announce(typeof data.description === 'string' ? data.description : data.message);
      return;
    }
    if (cartEl && sectionId && data.sections?.[sectionId]) {
      const parsed = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
      const next = parsed.querySelector('[data-cart-body]');
      const current = cartEl.querySelector('[data-cart-body]');
      if (next && current) current.replaceWith(next);
    }
    announce(statusEl?.dataset.addedLabel);
    document.dispatchEvent(new CustomEvent('drawer:request-open', { detail: { name: 'cart' } }));
  } catch {
    window.location.href = window.Theme?.routes?.cart_url ?? '/cart';
  }
}

function initBuy() {
  const form = document.querySelector('.pdp-buy__form');
  const addUrl = form ? `${form.action}.js` : null;

  // Sulle gift card il campo dell id non e' l hidden dentro il form: e' il select dei tagli, che
  // sta fuori e si aggancia con l attributo form. Si legge a ogni invio, non una volta sola, se no
  // si aggiunge sempre il primo taglio invece di quello scelto.
  const campoId = () =>
    form?.querySelector('[name="id"]') ?? document.querySelector('[name="id"][form="pdp-form"]');

  if (form && addUrl) {
    form.addEventListener('submit', (event) => {
      const id = campoId()?.value;
      if (!id) return;
      event.preventDefault();
      addToCart(id, addUrl, true, form);
    });
  }

  // Il bottone della barra sta fuori dal form: passando da requestSubmit si riusa lo stesso
  // handler e, soprattutto, i campi obbligatori vengono controllati come su un invio vero.
  const stickyBtn = document.querySelector('[data-pdp-sticky-atc]');
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', (event) => {
      event.preventDefault();
      form.requestSubmit();
    });
  }

  initAccessori();
}

function initAccessori() {
  const menu = document.querySelector('[data-accessory-dropdown]');
  if (!menu) return;

  const nome = menu.querySelector('[data-accessory-name]');
  const prezzo = menu.querySelector('[data-accessory-price]');
  const thumb = menu.querySelector('[data-accessory-thumb]');
  const opzioni = [...menu.querySelectorAll('[data-accessory-opt]')];

  const vuoto = { nome: nome?.textContent ?? '', prezzo: prezzo?.textContent ?? '' };

  for (const opt of opzioni) {
    opt.addEventListener('click', () => {
      const togli = opt.getAttribute('aria-pressed') === 'true';
      for (const altra of opzioni) altra.setAttribute('aria-pressed', String(!togli && altra === opt));
      if (nome) nome.textContent = togli ? vuoto.nome : opt.dataset.name ?? '';
      if (prezzo) prezzo.textContent = togli ? vuoto.prezzo : opt.dataset.price ?? '';
      if (thumb) {
        thumb.style.setProperty(
          '--accessory-thumb',
          !togli && opt.dataset.thumb ? `url("${opt.dataset.thumb}")` : 'none'
        );
      }
      menu.toggleAttribute('data-scelto', !togli);
      menu.open = false;
    });
  }

  anteprimaGalleria(menu, opzioni);

  document.addEventListener('click', (event) => {
    if (menu.open && !menu.contains(event.target)) menu.open = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
}

const ATTESA_ANTEPRIMA = 100;

function anteprimaGalleria(menu, opzioni) {
  const cella = document.querySelector('[data-gallery-first]');
  if (!cella) return;

  const livello = document.createElement('img');
  livello.className = 'pdp-gallery__preview';
  livello.alt = '';
  livello.loading = 'lazy';
  cella.append(livello);

  let attesa;
  let attesoOra = null;
  let caricato = null;
  const mostra = (src) => {
    clearTimeout(attesa);
    attesa = setTimeout(() => {
      attesoOra = src;
      // Si scopre solo a foto pronta: ha uno sfondo pieno, e mostrarlo durante lo scaricamento
      // coprirebbe la fotografia del prodotto con un rettangolo vuoto - su rete lenta a lungo,
      // su un indirizzo sbagliato per sempre. Il confronto con attesoOra evita che una risposta
      // in ritardo scopra l accessorio su cui non siamo piu.
      const pronta = () => {
        if (attesoOra === src) livello.setAttribute('data-visibile', '');
      };
      livello.onload = () => {
        caricato = src;
        pronta();
      };
      livello.onerror = () => {
        if (attesoOra === src) livello.removeAttribute('data-visibile');
      };
      // Sempre, anche se la foto e' gia' in cache: assegnare src annulla la richiesta di un altro
      // accessorio ancora in volo, che se no arriverebbe dopo e prenderebbe il posto di questa.
      livello.src = src;
      if (caricato === src) pronta();
    }, ATTESA_ANTEPRIMA);
  };
  const nascondi = () => {
    clearTimeout(attesa);
    attesoOra = null;
    attesa = setTimeout(() => livello.removeAttribute('data-visibile'), ATTESA_ANTEPRIMA);
  };

  for (const opt of opzioni) {
    const src = opt.dataset.preview;
    if (!src) continue;
    opt.addEventListener('mouseenter', () => mostra(src));
    opt.addEventListener('focusin', () => mostra(src));
    opt.addEventListener('mouseleave', nascondi);
    opt.addEventListener('focusout', nascondi);
  }

  menu.addEventListener('toggle', () => {
    if (!menu.open) nascondi();
  });
}

function initStickybar() {
  const bar = document.querySelector('.pdp-stickybar');
  const scheda = document.querySelector('.pdp-panel');
  if (!bar || !scheda || !('IntersectionObserver' in window)) return;

  let schedaPassata = false;
  let bottoniInVista = false;
  let codaInVista = false;
  const aggiorna = () => {
    bar.classList.toggle('is-visible', schedaPassata && !codaInVista);
    // sotto i 768 la barra sta su per conto suo (e' il solo modo di comprare): per ritirarla in coda
    // serve una classe sua, che il CSS mobile guarda.
    bar.classList.toggle('is-tail', codaInVista);
  };

  new IntersectionObserver(
    (entries) => {
      const e = entries[0];
      schedaPassata = !e.isIntersecting && e.boundingClientRect.top < 0;
      aggiorna();
    },
    { threshold: 0 }
  ).observe(scheda);

  // Quando i bottoni del Focus finiscono nella fascia bassa la barra ci passa sopra e si prende lei
  // il tocco. Prima per questo spariva; dall 8 set Alberto la vuole comunque a video, quindi l unica
  // cosa che resta e' saperlo: e' una sovrapposizione di ~7-10 mila px² in un tratto breve di scroll,
  // e per toglierla di mezzo bisogna spostare i bottoni o accorciare la barra, non spegnerla.
  // bottoniInVista resta misurato: serve a chi volesse riprendere in mano la cosa.
  const menuFocus = [...document.querySelectorAll('.pdp-feature__menu')].filter(
    (m) => m.querySelectorAll('[data-feat]').length > 1
  );
  if (menuFocus.length) {
    const visti = new Set();
    const spia = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) visti.add(e.target);
          else visti.delete(e.target);
        }
        bottoniInVista = visti.size > 0;
        aggiorna();
      },
      // Guarda solo il quarto basso dello schermo, che e' dove sta la barra: senza questo margine
      // basterebbe un pixel del menu in cima al viewport per farla sparire, e resterebbe nascosta
      // per tutta la sezione Focus anche quando non da' nessun fastidio.
      // ponytail: quota fissa invece dell altezza vera della barra, che cambia fra sold-out (191px)
      // e disponibile; il 25% copre il caso peggiore su un telefono, si misuri se serve piu' preciso.
      { threshold: 0, rootMargin: '-75% 0px 0px 0px' }
    );
    menuFocus.forEach((m) => spia.observe(m));
  }

  // In coda alla pagina il prodotto e' gia' stato visto: la barra si ritira invece di posarsi sopra
  // l ultimo modulo. Il grilletto e' la sezione su cui va a posarsi, cioe' quella che la precede: e' li' che
  // finisce la sua corsa e che il cliente la vedeva parcheggiata. Si guarda la posizione nel DOM e non
  // il nome della sezione, perche' l ordine cambia da template a template — nell archivio i correlati
  // stanno secondi, subito sotto la scheda, e prendendoli per nome la barra spariva da inizio pagina.
  // Le sezioni vuote (le recensioni oggi non hanno contenuto) misurano zero e vanno saltate.
  // La risalita si ferma alla scheda prodotto: se le sezioni in mezzo fossero tutte vuote (un prodotto
  // creato senza rassegna, faq, focus ed editoriale) si finirebbe a ridosso della scheda e la barra
  // risulterebbe ritirata da inizio pagina — sotto i 768 vuol dire senza add to cart.
  const sezione = bar.closest('.shopify-section');
  const sezioneScheda = scheda.closest('.shopify-section');
  // correlati e recensioni sono coda anche quando il template li mette altrove: nell archivio i
  // correlati stanno secondi, e risalendo diventerebbero il grilletto a una schermata dalla scheda.
  const eCoda = (n) =>
    n.classList.contains('pdp-related-section') || n.classList.contains('pdp-reviews');
  let coda = null;
  for (
    let n = sezione?.previousElementSibling;
    n && !coda && n !== sezioneScheda;
    n = n.previousElementSibling
  ) {
    if (n.offsetHeight > 0 && !eCoda(n)) coda = n;
  }
  for (let n = sezione?.nextElementSibling; n && !coda; n = n.nextElementSibling) {
    if (n.offsetHeight > 0) coda = n;
  }
  // ultimo ripiego: senza grilletto la barra tornerebbe a posarsi sopra il footer
  coda = coda || document.querySelector('.footer__top');
  if (coda) {
    new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        // non basta "sta intersecando la fascia": fra una sezione di coda e l altra ci sono buchi in
        // cui la barra tornerebbe su. Conta l aver raggiunto la fascia, e da li' in poi resta giu'.
        // isConnected perche' un nodo staccato (il theme editor ricarica le sezioni) misura tutto zero,
        // e senza guardia la barra resterebbe ritirata per sempre — sotto i 768 e' il solo add to cart.
        const fondo = e.rootBounds ? e.rootBounds.bottom : window.innerHeight;
        codaInVista = e.target.isConnected && e.boundingClientRect.top < fondo;
        aggiorna();
      },
      // niente margine: la barra sta in fondo allo schermo ed e' li' che la sezione entra, quindi il
      // ritiro parte appena si affaccia, non quando gli e' gia' sopra
      { threshold: 0 }
    ).observe(coda);
  }
}

function initZoom() {
  const galleria = document.querySelector('.pdp-gallery');
  const zoom = document.querySelector('[data-gallery-zoom]');
  const grande = zoom?.querySelector('[data-gallery-zoom-img]');
  if (!galleria || !zoom || !grande) return;

  let apertura = 0;

  for (const foto of galleria.querySelectorAll('.pdp-gallery__item img')) {
    foto.tabIndex = 0;
    foto.setAttribute('role', 'button');
  }

  galleria.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Enter' && evento.key !== ' ') return;
    const foto = evento.target.closest('.pdp-gallery__item img');
    if (!foto) return;
    evento.preventDefault();
    foto.click();
  });

  galleria.addEventListener('click', (evento) => {
    if (evento.target.closest('button')) return;
    const foto = evento.target.closest('.pdp-gallery__item img');
    if (!foto) return;

    const sorgente = foto.currentSrc || foto.src;
    // 2048 e non 1600: sotto lo zoom 2.5x la 1600 si sgranava
    const grandeSrc = sorgente.replace(/([?&]width=)\d+/, '$12048');
    const mia = ++apertura;

    azzeraZoom();
    grande.src = sorgente;
    grande.alt = foto.alt || '';
    if (foto.naturalWidth) {
      grande.width = foto.naturalWidth;
      grande.height = foto.naturalHeight;
    }
    zoom.showModal();

    // si apre con la foto gia scaricata e si sostituisce quando la grande e decodificata:
    // cambiando src subito, per due o tre secondi restava a video quella aperta prima
    const alta = new Image();
    alta.src = grandeSrc;
    alta
      .decode()
      .then(() => {
        if (mia === apertura) grande.src = grandeSrc;
      })
      .catch(() => {
      });
  });

  // Il box va misurato PRIMA di scalare e tenuto da parte: da zoomati getBoundingClientRect
  // restituisce il rettangolo gia ingrandito, e il pan inseguirebbe il dito invece di seguirlo.
  let boxBase = null;
  let origine = null;
  let ultimoTocco = null;
  // letto una volta sola all apertura dello zoom: getComputedStyle dentro il pan forzerebbe un
  // ricalcolo di stile a ogni movimento del dito, e sono decine al secondo
  let ingrandimento = 0;

  const fra0e100 = (v) => Math.min(100, Math.max(0, v));
  const applicaOrigine = () => {
    grande.style.transformOrigin = `${origine.x}% ${origine.y}%`;
  };

  // lente: l origine va dove sta il puntatore, quindi si guarda il punto indicato
  const puntaA = (evento) => {
    const r = boxBase ?? grande.getBoundingClientRect();
    origine = {
      x: fra0e100(((evento.clientX - r.left) / r.width) * 100),
      y: fra0e100(((evento.clientY - r.top) / r.height) * 100),
    };
    applicaOrigine();
  };

  // Col dito la lente e sbagliata: si tocca l immagine, quindi ci si aspetta di TRASCINARLA, e col
  // modello a lente il contenuto va dalla parte opposta alla mano. Spostare l origine di una quota
  // muove il contenuto ingrandito di (scala - 1) volte tanto, quindi per farlo seguire il dito di
  // dx pixel l origine va mossa di -dx / (scala - 1). La scala si legge dalla variabile CSS: cosi
  // resta un valore solo, quello del foglio di stile.
  const trascina = (evento) => {
    const r = boxBase ?? grande.getBoundingClientRect();
    if (!origine) return;
    if (!ultimoTocco) {
      ultimoTocco = { x: evento.clientX, y: evento.clientY };
      return;
    }
    if (ingrandimento <= 0) return;
    const dx = evento.clientX - ultimoTocco.x;
    const dy = evento.clientY - ultimoTocco.y;
    ultimoTocco = { x: evento.clientX, y: evento.clientY };
    origine = {
      x: fra0e100(origine.x - (dx / (r.width * ingrandimento)) * 100),
      y: fra0e100(origine.y - (dy / (r.height * ingrandimento)) * 100),
    };
    applicaOrigine();
  };

  grande.addEventListener('click', (evento) => {
    // il click sull'immagine zooma invece di chiudere; da zoomati il primo click torna indietro
    // e solo dopo si puo chiudere toccando fuori, che su telefono e l unica via d uscita
    evento.stopPropagation();
    if (grande.classList.contains('is-zoomed')) {
      azzeraZoom();
      return;
    }
    boxBase = grande.getBoundingClientRect();
    ingrandimento = (parseFloat(getComputedStyle(grande).getPropertyValue('--pdp-zoom-scale')) || 2.5) - 1;
    puntaA(evento);
    grande.classList.add('is-zoomed');
  });

  // ogni volta che il dito si riappoggia il conteggio riparte, se no il primo movimento fa un salto
  grande.addEventListener('pointerdown', () => {
    ultimoTocco = null;
  });

  // da zoomati si sposta l inquadratura muovendo il puntatore, o trascinando il dito
  grande.addEventListener('pointermove', (evento) => {
    if (!grande.classList.contains('is-zoomed')) return;
    if (evento.pointerType === 'mouse') {
      puntaA(evento);
      return;
    }
    if (!evento.buttons) return;
    trascina(evento);
  });

  const azzeraZoom = () => {
    grande.classList.remove('is-zoomed');
    grande.style.transformOrigin = '';
    boxBase = null;
    origine = null;
    ultimoTocco = null;
    ingrandimento = 0;
  };

  zoom.addEventListener('click', () => zoom.close());
  zoom.addEventListener('close', azzeraZoom);
  // col viewport cambiato il box misurato non vale piu e il pan resterebbe sfasato
  addEventListener('resize', () => {
    if (zoom.open) azzeraZoom();
  });
}

initDayNight();
initTabs();
initBuy();
initStickybar();
initZoom();
